import { render, staticRenderFns } from "./PageContent.vue?vue&type=template&id=cf7e4524&scoped=true"
import script from "./PageContent.vue?vue&type=script&lang=js"
export * from "./PageContent.vue?vue&type=script&lang=js"
import style0 from "./PageContent.vue?vue&type=style&index=0&id=cf7e4524&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7e4524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf7e4524')) {
      api.createRecord('cf7e4524', component.options)
    } else {
      api.reload('cf7e4524', component.options)
    }
    module.hot.accept("./PageContent.vue?vue&type=template&id=cf7e4524&scoped=true", function () {
      api.rerender('cf7e4524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/PageContent.vue"
export default component.exports